if (!customElements.get('before-after-section')) {
  class BeforeAfterSection extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;

      // Elements
      this.productSlides = this.querySelectorAll('.ba-product-slide');
      this.imageSlides = this.querySelectorAll('.ba-image-slide');
      this.btnPrev = this.querySelector('.js-ba-prev');
      this.btnNext = this.querySelector('.js-ba-next');
      this.rangeInputs = this.querySelectorAll('.ba-range');
      this.wrappers = this.querySelectorAll('.ba-comparison-inner');

      this.init();
    }

    init() {
      if (this.productSlides.length === 0) return;

      // Initial state setup
      this.updateActiveSlide(0);

      // Add-to-cart feedback (AJAX drawer)
      this.querySelectorAll('.ba-product-actions form').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('.ba-add-to-cart');
          if (!btn || btn.disabled) return;
          const orig = btn.textContent;
          btn.textContent = 'Adding…';
          btn.disabled = true;

          try {
            const formData = new FormData(form);
            const variantId = parseInt(formData.get('id'));
            if (!variantId) throw new Error('Missing variant id');

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: variantId,
                quantity: 1,
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
              })
            });

            if (!res.ok) throw new Error('Could not add to cart');
            const parsedState = await res.json();

            // Update cart bubble
            const bubbleHtml = parsedState.sections?.['cart-icon-bubble'];
            if (bubbleHtml) {
              const tempBubble = document.createElement('div');
              tempBubble.innerHTML = bubbleHtml;
              const newBubble = tempBubble.querySelector('#cart-icon-bubble');
              const currentBubble = document.getElementById('cart-icon-bubble');
              if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
            }

            // Open cart drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(parsedState);
              } else {
                const drawerHtml = parsedState.sections?.['cart-drawer'];
                if (drawerHtml) {
                  const tempDrawer = document.createElement('div');
                  tempDrawer.innerHTML = drawerHtml;
                  const newDrawer = tempDrawer.querySelector('cart-drawer') || tempDrawer.firstElementChild;
                  if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
                }
                cartDrawer.classList.add('active', 'animate', 'is-open');
                cartDrawer.classList.remove('is-empty');
                const innerDrawer = cartDrawer.querySelector('.drawer');
                if (innerDrawer) innerDrawer.classList.add('active', 'animate', 'is-open');
                document.body.classList.add('overflow-hidden');
              }
            } else {
              const cartNotification = document.querySelector('cart-notification');
              if (cartNotification && typeof cartNotification.renderContents === 'function') {
                cartNotification.renderContents(parsedState);
              } else if (cartNotification && typeof cartNotification.open === 'function') {
                cartNotification.open();
              } else {
                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) cartIcon.click();
                else window.location.href = window.routes?.cart_url || '/cart';
              }
            }

            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: parsedState }));

            btn.textContent = 'Added ✓';
            btn.classList.add('is-added');
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; btn.classList.remove('is-added'); }, 2000);
          } catch (err) {
            console.error('Add to cart error:', err);
            btn.textContent = 'Error';
            setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
          }
        });
      });

      // Next / Prev listeners
      if (this.btnNext && this.btnPrev) {
        this.btnNext.addEventListener('click', () => {
          let nextIndex = this.activeIndex + 1;
          if (nextIndex >= this.productSlides.length) nextIndex = 0;
          this.updateActiveSlide(nextIndex);
        });

        this.btnPrev.addEventListener('click', () => {
          let prevIndex = this.activeIndex - 1;
          if (prevIndex < 0) prevIndex = this.productSlides.length - 1;
          this.updateActiveSlide(prevIndex);
        });
      }

      // Range slider listeners for Before/After effect
      this.rangeInputs.forEach(range => {
        range.addEventListener('input', (e) => {
          this.updateSliderPosition(e.target);
        });
      });

      // Resize observer to keep the before image the correct width so it clips properly instead of squashing
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const containerWidth = entry.contentRect.width;
          const slide = entry.target;
          const beforeImg = slide.querySelector('.ba-img-before-actual');
          if (beforeImg) {
            beforeImg.style.width = `${containerWidth}px`;
          }
        }
      });

      this.imageSlides.forEach(slide => {
        this.resizeObserver.observe(slide);

        // Trigger initial slider position setup
        const range = slide.querySelector('.ba-range');
        if (range) this.updateSliderPosition(range);
      });
    }

    updateActiveSlide(index) {
      // Remove active from all
      this.productSlides.forEach(slide => slide.classList.remove('is-active'));
      this.imageSlides.forEach(slide => slide.classList.remove('is-active'));

      // Add active to new index
      this.activeIndex = index;
      if (this.productSlides[index]) this.productSlides[index].classList.add('is-active');
      if (this.imageSlides[index]) this.imageSlides[index].classList.add('is-active');
    }

    updateSliderPosition(rangeInput) {
      const value = rangeInput.value;
      const slide = rangeInput.closest('.ba-image-slide');
      const beforeWrapper = slide.querySelector('.ba-img-before-wrapper');
      const handle = slide.querySelector('.ba-handle');

      if (beforeWrapper) beforeWrapper.style.width = `${value}%`;
      if (handle) handle.style.left = `${value}%`;
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  customElements.define('before-after-section', BeforeAfterSection);
}
